// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__33lSb","row":"ProcedureTreatmentSummary_row__PVZna"};